<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>

<div class="container mt-4">
  <div class="row">
    <div class="col-12">
      <div class="row">
        <!-- Formulário de Perfil -->
        <div class="col-md-7">
          <div class="card">
            <div class="card-header">
              <h4 class="mb-0">Meu Perfil</h4>
            </div>
            <div class="card-body">
              <!-- Mensagens de feedback -->
              <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
                {{ successMessage }}
                <button type="button" class="btn-close" (click)="successMessage = ''"></button>
              </div>
              <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
                {{ errorMessage }}
                <button type="button" class="btn-close" (click)="errorMessage = ''"></button>
              </div>

              <!-- Loading spinner -->
              <div *ngIf="loading" class="text-center my-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Carregando...</span>
                </div>
              </div>

              <form [formGroup]="perfilForm" (ngSubmit)="onSubmit()" *ngIf="!loading">
                <!-- Dados Pessoais -->
                <div class="card mb-4">
                  <div class="card-header">
                    <h5 class="mb-0">Dados Pessoais</h5>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label for="NOME" class="form-label">Nome Completo</label>
                        <input
                          type="text"
                          class="form-control"
                          id="NOME"
                          formControlName="NOME"
                          [ngClass]="{'is-invalid': perfilForm.get('NOME')?.invalid && perfilForm.get('NOME')?.touched}"
                        >
                        <div class="invalid-feedback" *ngIf="perfilForm.get('NOME')?.invalid && perfilForm.get('NOME')?.touched">
                          Nome é obrigatório
                        </div>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label for="CPF" class="form-label">CPF</label>
                        <input
                          type="text"
                          class="form-control"
                          id="CPF"
                          formControlName="CPF"
                          [textMask]="{mask: cpfMask}"
                          [ngClass]="{'is-invalid': perfilForm.get('CPF')?.invalid && perfilForm.get('CPF')?.touched}"
                        >
                        <div class="invalid-feedback" *ngIf="perfilForm.get('CPF')?.invalid && perfilForm.get('CPF')?.touched">
                          CPF inválido
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label for="EMAIL" class="form-label">E-mail</label>
                        <input
                          type="email"
                          class="form-control"
                          id="EMAIL"
                          formControlName="EMAIL"
                          readonly
                          [ngClass]="{'is-invalid': perfilForm.get('EMAIL')?.invalid && perfilForm.get('EMAIL')?.touched}"
                        >
                        <div class="invalid-feedback" *ngIf="perfilForm.get('EMAIL')?.invalid && perfilForm.get('EMAIL')?.touched">
                          E-mail inválido
                        </div>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label for="TELEFONE" class="form-label">Telefone</label>
                        <input
                          type="text"
                          class="form-control"
                          id="TELEFONE"
                          formControlName="TELEFONE"
                          [textMask]="{mask: telefoneMask}"
                          [ngClass]="{'is-invalid': perfilForm.get('TELEFONE')?.invalid && perfilForm.get('TELEFONE')?.touched}"
                        >
                        <div class="invalid-feedback" *ngIf="perfilForm.get('TELEFONE')?.invalid && perfilForm.get('TELEFONE')?.touched">
                          Telefone inválido
                        </div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <label for="ENDERECO" class="form-label">Endereço Completo</label>
                      <textarea
                        class="form-control"
                        id="ENDERECO"
                        formControlName="ENDERECO"
                        rows="3"
                        [ngClass]="{'is-invalid': perfilForm.get('ENDERECO')?.invalid && perfilForm.get('ENDERECO')?.touched}"
                      ></textarea>
                      <div class="invalid-feedback" *ngIf="perfilForm.get('ENDERECO')?.invalid && perfilForm.get('ENDERECO')?.touched">
                        Endereço é obrigatório
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Botões -->
                <div class="text-end">
                  <button
                    type="submit"
                    class="btn"
                    [disabled]="perfilForm.invalid || isSubmitting"
                    style="background-color: #2c4864; color: white;"
                  >
                    <span *ngIf="!isSubmitting">
                      <i class="fas fa-save me-2"></i>
                      Salvar Alterações
                    </span>
                    <span *ngIf="isSubmitting" class="d-flex align-items-center">
                      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Salvando...
                    </span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- Formulário de Alteração de Senha -->
        <div class="col-md-5">
          <div class="card">
            <div class="card-header">
              <h4 class="mb-0">Alterar Senha</h4>
            </div>
            <div class="card-body">
              <!-- Mensagens de feedback da senha -->
              <div *ngIf="senhaSuccessMessage" class="alert alert-success alert-dismissible fade show" role="alert">
                {{ senhaSuccessMessage }}
                <button type="button" class="btn-close" (click)="senhaSuccessMessage = ''"></button>
              </div>
              <div *ngIf="senhaErrorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
                {{ senhaErrorMessage }}
                <button type="button" class="btn-close" (click)="senhaErrorMessage = ''"></button>
              </div>

              <form [formGroup]="senhaForm" (ngSubmit)="onSubmitSenha()">
                <div class="mb-3">
                  <label for="login" class="form-label">Login</label>
                  <input
                    type="text"
                    class="form-control"
                    id="login"
                    [value]="perfilForm.get('EMAIL')?.value"
                    readonly
                    disabled
                  >
                </div>

                <div class="mb-3">
                  <label for="senhaAtual" class="form-label">Senha Atual</label>
                  <input
                    type="password"
                    class="form-control"
                    id="senhaAtual"
                    formControlName="senhaAtual"
                    [ngClass]="{'is-invalid': senhaForm.get('senhaAtual')?.invalid && senhaForm.get('senhaAtual')?.touched}"
                  >
                  <div class="invalid-feedback" *ngIf="senhaForm.get('senhaAtual')?.invalid && senhaForm.get('senhaAtual')?.touched">
                    Senha atual é obrigatória
                  </div>
                </div>

                <div class="mb-3">
                  <label for="novaSenha" class="form-label">Nova Senha</label>
                  <input
                    type="password"
                    class="form-control"
                    id="novaSenha"
                    formControlName="novaSenha"
                    [ngClass]="{'is-invalid': senhaForm.get('novaSenha')?.invalid && senhaForm.get('novaSenha')?.touched}"
                  >
                  <div class="invalid-feedback" *ngIf="senhaForm.get('novaSenha')?.invalid && senhaForm.get('novaSenha')?.touched">
                    Nova senha é obrigatória
                  </div>
                </div>

                <div class="mb-3">
                  <label for="confirmarSenha" class="form-label">Confirmar Nova Senha</label>
                  <input
                    type="password"
                    class="form-control"
                    id="confirmarSenha"
                    formControlName="confirmarSenha"
                    [ngClass]="{'is-invalid': senhaForm.get('confirmarSenha')?.invalid && senhaForm.get('confirmarSenha')?.touched}"
                  >
                  <div class="invalid-feedback" *ngIf="senhaForm.get('confirmarSenha')?.invalid && senhaForm.get('confirmarSenha')?.touched">
                    Confirmação de senha é obrigatória
                  </div>
                </div>

                <div class="text-end">
                  <button
                    type="submit"
                    class="btn"
                    [disabled]="senhaForm.invalid || isSubmittingSenha"
                    style="background-color: #2c4864; color: white;"
                  >
                    <span *ngIf="!isSubmittingSenha">
                      <i class="fas fa-key me-2"></i>
                      Alterar Senha
                    </span>
                    <span *ngIf="isSubmittingSenha" class="d-flex align-items-center">
                      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Alterando...
                    </span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 